import { useT } from "@/lib/i18n";
import { useOfferUsage } from "@/lib/services/offer-service";
import { CatalogPicker, type CatalogOption } from "./catalog-picker";

export interface OfferPickerProps {
  value?: string;
  onChange: (id: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

/** An offer from the whole catalog, with where it is already used. */
export function OfferPicker(props: OfferPickerProps) {
  return <CatalogPicker kind="offer" {...props} renderSub={(o) => <OfferUsageHint option={o} />} />;
}

function OfferUsageHint({ option }: { option: CatalogOption }) {
  const t = useT();
  const { data } = useOfferUsage(option.id);
  const line = [option.sub, data && data.flowCount > 0 ? t("picker.usedIn", { flows: data.flowCount, campaigns: data.campaignCount }) : ""].filter(Boolean).join(" · ");
  return line ? <span className="block truncate text-xs text-muted-foreground">{line}</span> : null;
}
